import React, { createContext, useContext, useState } from 'react';

const FlowContext = createContext();

export const useFlow = () => {
  const context = useContext(FlowContext);
  if (!context) {
    throw new Error('useFlow must be used within a FlowProvider');
  }
  return context;
};

export const FlowProvider = ({ children }) => {
  const [flowNumber, setFlowNumber] = useState(1);
  console.log('FlowProvider initialized with flowNumber:', flowNumber);
  const getBasePath = () => {
    return flowNumber === 1 ? '' : `/${flowNumber}`;
  };

  const value = {
    flowNumber,
    setFlowNumber,
    getBasePath,
  };

  return <FlowContext.Provider value={value}>{children}</FlowContext.Provider>;
};
